import React from 'react';
import './About.css';
import carabiner from '../assets/carabiner.png';

const stats = [
  { value: '4+', label: 'YEARS DEV' },
  { value: 'V6', label: 'MAX GRADE' },
  { value: '4+', label: 'PROJECTS SHIPPED' },
];

const About: React.FC = () => {
  return (
    <section className="about" id="about">
      <div className="about__image-col">
        <div className="about__image-wrap">
          <div className="about__image" aria-label="Profile photo">
            <img src={carabiner} alt="Carabiner" className="about__avatar" />
          </div>
        </div>
      </div>

      <div className="about__content">
        <p className="about__eyebrow">BIOGRAPHY</p>
        <h2 className="about__heading">
          The Engineer &amp;<br />The Climber.
        </h2>
        <p className="about__body">
          In the high-stakes environment of bouldering, every placement and movement is a calculated decision.
          I bring this same technical rigor to software architecture. Whether it's designing a scalable system
          or finding the perfect "beta", the objective is the same: absolute efficiency.
        </p>
        <p className="about__body">
          With over 4 years of experience in full-stack development, I specialize in building resilient systems
          that handle scale with the same grace a climber handles a technical slab. I believe that elegant code
          and elegant movement are two sides of the same coin.
        </p>
        <div className="about__stats">
          {stats.map((s) => (
            <div className="about__stat" key={s.value}>
              <span className="about__stat-value">{s.value}</span>
              <span className="about__stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
